import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { FIREBASE_CONFIG } from './utils/apiBase';

const Firebase = firebase.initializeApp(FIREBASE_CONFIG);
export default Firebase;
